/**
 * Fireblocks integration API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';

export interface FireblocksDepositVault {
  id?: number;
  accountId?: number;
  account?: Account;
  externalId?: string;
  name?: string;
  hiddenOnUI?: boolean;
  autoSweep?: boolean;
  businessEntity?: FireblocksDepositVault.BusinessEntityEnum;
}
export namespace FireblocksDepositVault {
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
